module.exports = __webpack_public_path__ + "static/media/help2.7c72d2c2.png";